<template>

  <a :href="post.link" class="card mb-3 h-100 text-decoration-none" :class="cardClass">
    <img v-if="post.image && post.image.sizes" class="card-img-top" :src="post.image.sizes.medium" :alt="post.image.alt" />
    <img v-else-if="post.image && !post.image.sizes" class="card-img-top" :src="post.image" :alt="post.image.alt" />
    <div v-else v-html="fallbackImage"></div>
    <div class="card-body">
      <time v-if="post.type[0] === 'events'" class="card-meta">
        <span class="dot d-inline-block mr-2 rounded-circle"
              :class="getBgColor(post.color)" aria-hidden="true"></span>{{ post.meta.start_date_time | formatDateEvent }}
      </time>
      <span v-else-if="post.theme.length > 0" class="card-meta">
        <span class="dot d-inline-block mr-2 rounded-circle"
              :class="getBgColor(post.color)" aria-hidden="true"></span>
        <span class="d-inline-block" v-html="post.theme[0]"></span>
      </span>
      <h2 class="card-title mb-0">
        {{ post.title }}
        <span v-if="post.meta.premium" class="badge-premium"></span>
      </h2>
      <time v-if="post.type[0] === 'post'" class="card-meta" v-html="post.date"></time>
    </div>
  </a>
</template>

<script>
  export default {
    name: 'post',
    props: {
      post: {
        type: Object,
        required: true
      },
      cardClass: {
        type: String,
        required: false,
        default: 'card--search'
      }
    },
    mounted() {
      this.fallbackImage = ajax_object.fallback_image;
    },
    data() {
      return {
        fallbackImage: ''
      }
    },
    methods: {
      getBgColor(color) {
        return `bg-${color}`;
      }
    },
    filters: {
      formatDateEvent: function(value) {
        if (value) {
          const months = [
            'januari', 'februari', 'maart', 'april',
            'mei', 'juni', 'juli', 'augustus',
            'september', 'oktober', 'november', 'december'
          ];
          const date = new Date(value);
          const day = date.getDate();
          const monthIndex = date.getMonth();
          const year = date.getFullYear();
          const monthName = months[monthIndex];
          return `${day} ${monthName} ${year}`;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .meta__thema a:not(:last-child):after {
    content: '|';
  }
</style>
